(L => {
	'use strict';

	let events = [];
	let id = 0;
	let bound;
	let current;

	/**
	 * Bind individual rule
	 *
	 * @private
	 * @param {Object} conf - breakpoint rules
	 * @param {Array} [conf.args] - callback arguments
	 * @param {Function} conf.callback
	 * @param {Boolean} [conf.each=false] - execute for each matching breakpoint
	 * @param {Boolean} [conf.init=true] - check event on load
	 * @param {Number} [conf.max] - maximum breakpoint value
	 * @param {Number} [conf.min] - minimum breakpoint value
	 * @param {Boolean} [conf.once=false] - only execute the callback once
	 * @param {Object} [conf.scope] - callback scope
	 * @param {Number} [conf.size] - specific breakpoint value
	 * @param {Boolean} [conf.watch=true] - check event on screen resize
	 * @param {String} [conf.namespace] - namespace the event
	 */
	const _addRule = conf => {
		// Attach unique identifier
		conf.i = id++;

		// Only setup watching when enabled
		if (conf.watch !== false) {
			events.push(conf);

			// Only attach event once
			if (! bound) {
				bound = _run.bind(this, false, 0);
				events = [conf];

				// Attach resize event
				L._win.addEventListener('resize', bound, false);
			}
		}

		// Evaluate rule immediately if not disabled
		if (conf.init !== false) {
			_run(true, [conf]);
		}
	};

	/**
	 * Check mapped rules for matching conditions
	 *
	 * @private
	 * @param {Boolean} [init=false] - initial page load
	 * @param {Array} [rules] - breakpoint rules
	 */
	const _run = (init, rules) => {
		const size = L.screen.size();

		// If breakpoint has been hit or resize logic initialized
		if (size && (init || size !== current)) {
			const evts = rules || events;

			let i = evts.length;

			while (i--) {
				const evt = evts[i];

				if (_eq(evt, size, init)) {
					const f = init && ! current;
					const data = {
						dir: f ? 0 : (size > current ? 1 : -1),
						init: init,
						prev: current,
						size: size
					};

					L.$exec(evt.callback, {
						args: evt.args ? [data].concat(evt.args) : data,
						scope: evt.scope
					});

					// Disable future execution if once
					if (evt.once) {
						events = events.filter(obj => obj.i !== evt.i);
					}
				}
			}

			// Cache current value
			current = size;
		}
	};

	/**
	 * Compare event rules against current size
	 *
	 * @private
	 * @param {Object} evt
	 * @param {Number} size
	 * @param {Boolean} init
	 * @returns {Boolean}
	 */
	const _eq = (evt, size, init) => {
		const sz = evt.size;
		const mn = evt.min;
		const mx = evt.max;
		const ex = evt.each || init;

		// Check match against rules
		return (! sz && ! mn && ! mx) ||
			(sz && sz === size) ||
			(mn && size >= mn && (ex || current < mn) && (! mx || size <= mx)) ||
			(mx && size <= mx && (ex || current > mx) && (! mn || size >= mn));
	};

	L.screen = {
		/**
		 * Get current breakpoint value
		 *
		 * @returns {Number} size
		 */
		size() {
			return parseFloat(
				getComputedStyle(L._html, null)
					.getPropertyValue('font-family')
					.replace(/[^\d.]+/g, '')
			);
		},

		/**
		 * Map conditional events to breakpoint values
		 *
		 * @param {Array|Object} rules - breakpoint rules
		 * @param {Array} [rules.args] - callback arguments
		 * @param {Function} rules.callback
		 * @param {Boolean} [rules.each=false] - execute for each matching breakpoint
		 * @param {Boolean} [rules.init=true] - check event on load
		 * @param {Number} [rules.max] - maximum breakpoint value
		 * @param {Number} [rules.min] - minimum breakpoint value
		 * @param {String} [rules.namespace] - namespace the event
		 * @param {Boolean} [rules.once=false] - only execute the callback once
		 * @param {Object} [rules.scope] - callback scope
		 * @param {Number} [rules.size] - specific breakpoint value
		 * @param {Boolean} [rules.watch=true] - check event on screen resize
		 * @param {Object} [options] - common settings merged into each rule
		 */
		map(rules, options) {
			const sets = L.$toArray(rules);

			let i = sets.length;

			while (i--) {
				_addRule(
					Object.assign(sets[i], options)
				);
			}
		},

		/**
		 * Evaluate the current breakpoint
		 */
		run() {
			_run(true);
		},

		/**
		 * Remove events from bound rules
		 *
		 * @param {String} [namespace] - remove screen events in this namespace
		 */
		reset(namespace) {
			events = events.filter(obj => obj.namespace !== namespace);

			if (bound && ! events.length) {
				L._win.removeEventListener('resize', bound);

				bound = 0;
			}
		}
	};
})(Apt);